// extracted by mini-css-extract-plugin
export default {"withdrawalRecordWrapper":"CashWithdrawRecord_withdrawalRecordWrapper__FGGzu","noDataContainer":"CashWithdrawRecord_noDataContainer__Hmufq"};